import { type ComponentType, type ReactNode } from 'react';

import { dynamic } from '#/utils/dynamic';

export function clientOnlyLazy<
  // oxlint-disable-next-line typescript/no-explicit-any
  T extends ComponentType<any>,
>(
  load: () => Promise<{ default: T }>,
  options?: { placeholder?: ReactNode; desktopOnly?: boolean },
) {
  return dynamic(load, {
    strategy: options?.desktopOnly ? 'client-desktop-only' : 'client-only',
    placeholder: options?.placeholder,
  });
}
